var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("8、企业对未使用、不需用的固定资产也应计提折旧，计提的折旧计入（　）。")])])
}]

export { render, staticRenderFns }